// 设备连接白名单
export const deviceWhiteList = [
  "/deviceDetail",
  "/connectDevice",
  "/chooseSeal",
  "/installSeal",
  "/selectPeople",
  "/enteringFingerprint",
  "/fingerprint",
  "/dipInk",
  "/addInk",
  "/upgradeDevice",
  "/sealSetting",
  "/chooseDevice",
  "/testFingerprint",
  "/normalPrint",
  "/remotePrint",
  "/remotePrintResult",
  "/continuousPrint",
  "/remake",
  "/ocrRemake",
  "/updating",
  "/waitUse",
  "/applyDetail",
  "/recordDetail",
  "/exportPdf",
  "/normalContinuous",
  "/findDevices",
  "/qrcodePrintCamera", //二维码水印用印页面
  "/chooseFile",
  "/remoteOcrDiff",
  "/applyList", //用印管理页面
  "/ocrView",
  "/sealChangeSure", //wifi配置页
  "/wifi",
  "/useDevice",
  "/longRange",
  "/longRangeSeal", // TODO  后续下看是否需要 不需要删除
  "/sealChangeApply",
  "/upgradeOta",
  "/archive",
  "/padUseSeal",
  "/facePhoto",
  "/envChange",
  '/connectChange',
  // '/addTemporary',
  // '/temporaryPeople'
];

// 连接设备过后的页面
export const deviceWhiteLists = [
  "/chooseSeal",
  "/installSeal",
  "/selectPeople",
  "/enteringFingerprint",
  "/dipInk",
  "/addInk",
  "/updating",
  "/upgradeDevice", // 设备详情相关
  "/testFingerprint",
  "/normalPrint",
  "/remotePrint",
  "/remotePrintResult",
  "/continuousPrint", // 盖印相关页面
  "/ocrRemake", // OCR对比拍照页面
  "/normalContinuous", //连续常规页面（无相机无视频）
  "/findDevices",
  "/qrcodePrintCamera", //二维码水印用印页面
  "/chooseFile",
  "/sealChangeSure",
  // '/remoteOcrDiff'
  "/useDevice",
  "/longRange",
  "/longRangeSeal",
  "/upgradeOta",
  "/facePhoto",
  "/envChange",
  '/connectChange',
];
